<template>
  <div class="personal-data-component">
    <div class="personal-data">
      <ProfileNavbar></ProfileNavbar>
      <div class="data-wrap">
        <div class="base-info-wrap">
          <div class="address-info-wrap">
            <div class="address-count-tip">共{{ list.length }}个收款账户，最多保存10个</div>
            <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
              highlight-current-row>
              <el-table-column label="收款人" align="center" width="150" prop="payee">
                <template slot-scope="{row}">
                  <p>{{ row.payee }}</p>
                </template>
              </el-table-column>
              <el-table-column label="收款方式" align="center" width="150" prop="method_name">
              </el-table-column>
              <el-table-column label="收款信息" align="center" minWidth="180">

                <template slot-scope="{row}">
                  <template v-if="row.method == 0">
                    <p>微信号：{{ row.account }}</p>
                  </template>

                  <template v-if="row.method == 1">
                    <p>支付宝账号：{{ row.account }}</p>
                  </template>

                  <template v-if="row.method == 2">
                    <p>开户行：{{ row.bank_name }}</p>
                    <p>银行行号：{{ row.bank_code }}</p>
                    <p>银行卡号：{{ row.account }}</p>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="是否默认" align="center" minWidth="80">
                <template slot-scope="{row}">
                  <p>{{ row.is_default ? '是' : '否' }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200" fixed="right">
                <template slot-scope="{row}">
                  <el-button type="text" @click="handleShowEditAccount(row)">编辑</el-button>
                  <el-button type="text" @click="handleDeleteAccount(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="add-address-wrap" @click="handleShowAddAccount">
              <div class="add-icon">+</div>
              <p>新增收款账户（最多添加10个）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建账户 -->
    <add-account :visible.sync="showAddForm" @getList="getList" />
    <!-- 编辑账户 -->
    <edit-account :oldAccount="oldAccount" :visible.sync="showEditForm" @getList="getList" />
  </div>
</template>

<script>
import { getAccountList, deleteAccount } from "@/api/account";
import ProfileNavbar from "@/components/profileNavbar"
import AddAccount from "./components/addAccount"
import EditAccount from "./components/editAccount"
export default {
  name: 'UserAccount',
  components: {
    ProfileNavbar,
    AddAccount,
    EditAccount,
  },
  data() {
    return {
      loading: false,
      showAddForm: false,
      showEditForm: false,
      list: [],
      oldAccount: {},
      emptyText: '暂无数据',
      total: 0,
      listQuery: {
        page: 1,
        pagesize: 10
      },
    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getAccountList({}).then(res => {
        this.list = res.data.list;
        this.total = res.data.count * 1;
        this.loading = false;
      }).catch((err) => {

      });
    },
    // 删除项目
    handleDeleteAccount(account) {
      this.$confirm('确定要删除此账户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        deleteAccount({
          id: account.id
        })
          .then((response) => {
            this.loading = false;
            this.getList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    handleShowAddAccount() {
      this.showAddForm = true;
    },
    handleShowEditAccount(account) {
      this.oldAccount = account
      this.showEditForm = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/profile.less';
</style>
